export enum PresenterTabsOnMobile {
  CLICKER = 'Clicker',
  NOTES = 'Notes',
  QUESTIONS = 'Questions',
}

export enum LiveStreamStatus {
  STAND_BY = 'STAND_BY',
  BROADCASTING = 'RESUME',
  START_BROADCASTING = 'START_BROADCASTING',
  INTERMISSION = 'INTERMISSION',
  END_BROADCASTING = 'END_BROADCASTING',
  ENDED = 'ENDED',
}
